// import React from "react";
// import { ErrorMessage, Field, FormikProvider, useFormik } from "formik";
// import * as Yup from "yup";
// import { useState, useEffect, useRef } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import {AREA_STATISTICS, ASI_DOMAIN, BUSINESSREG_DOMAIN, IIP_DOMAIN, LOGIN_DOMAIN, MDP, RAIN_DOMAIN, SLAP_DOMAIN, TRAS_DOMAIN, VIS, YIELD_DOMAIN} from "../Services/Configuration.js";
// import { store } from "../App.js";
// import DesService from "../Services/Des Service.js";
// import { FaEye, FaEyeSlash } from "react-icons/fa";
// import ShowAlert from "./alert.js";
// import { TbRefresh } from "react-icons/tb";
// import { Button, Form, InputGroup } from "react-bootstrap";
// import { BsBoxArrowInRight } from "react-icons/bs";
// import { Progress } from "antd";

// export default function Login() {
//   var createHost = require("cross-domain-storage/host");
//   var createGuest = require("cross-domain-storage/guest");
//   var mainAppguest = null;

//   var storageHost = null;
//   const [loginErrorMsg, setloginErrorMsg] = useState(false);
//   const navigate = useNavigate();
//   const [username, setUsername] = useState("");
//   const [passwordType, setPasswordType] = useState("password");

//   const [errMsg, setErrMsg] = useState("");
//   const [loginEnb, setLoginEnb] = useState();
//   const [captchaInput, setCaptchaInput] = useState("");
//   const [captchaText, setCaptchaText] = useState("");
//   const canvasRef = useRef(null);

//   useEffect(() => {
//     // localStorage.clear();

//     storageHost = createHost([
//       {
//         origin: LOGIN_DOMAIN,
//         allowedMethods: ["get", "set", "remove"],
//       },
//       {
//         origin: RAIN_DOMAIN,
//         allowedMethods: ["get", "set", "remove"],
//       },
//       {
//         origin: IIP_DOMAIN,
//         allowedMethods: ["get", "set", "remove"],
//       },
//       {
//         origin: YIELD_DOMAIN,
//         allowedMethods: ["get", "set", "remove"],
//       },
//       {
//         origin: BUSINESSREG_DOMAIN,
//         allowedMethods: ["get", "set", "remove"],
//       },
//       {
//         origin: TRAS_DOMAIN,
//         allowedMethods: ["get", "set", "remove"],
//       },
//       {
//         origin: ASI_DOMAIN,
//         allowedMethods: ["get", "set", "remove"],
//       },
//       {
//         origin: AREA_STATISTICS,
//         allowedMethods: ["get", "set", "remove"],
//       },
//       {
//         origin: SLAP_DOMAIN,
//         allowedMethods: ["get", "set", "remove"],
//       },
//       {
//         origin: MDP,
//         allowedMethods: ["get", "set", "remove"],
//       },
//         {
//         origin: VIS,
//         allowedMethods: ["get", "set", "remove"],
//       }

//     ]);
//     // storageHost.close()
//   }, []);

//   const initialValues = {
//     usr: "",
//     psd: "",
//     captcha: "",
//   };

//   const validationSchema = Yup.object().shape({
//     usr: Yup.string().required("Required"),
//     psd: Yup.string().required("Required"),
//     captcha: Yup.string()
//       .required("Required")
//       .test("is-exactly-5-values", "Invalid Captcha", (value) => {
//         return value ? value.split("").filter(Boolean).length === 5 : false;
//       }),
//   });

//   const formik = useFormik({
//     initialValues: initialValues,
//     validationSchema: validationSchema,
//     onSubmit: (values) => {
//       console.log("username", username);
//       let params = { username: values.usr, password: values.psd, capchaId: values.captcha, sessionId: sessioId };
//       store.dispatch({ type: "SHOW_SPINNER" });
//       DesService.loginDetails(params).then((response) => {
//         if (response?.data !== "" && response?.data !== null && response?.data !== undefined) {
//           console.log("response?.data?.SCODE" + response?.data?.SCODE);
//           if (response.data?.token) {
//             console.log(response?.data?.SDESC?.userid);
//             console.log(response?.data?.SDESC?.roleid);
//            localStorage.setItem( "portalurl", window.location.origin );
//             localStorage.setItem("user", JSON.stringify(response.data));
//             localStorage.setItem("token", response.data?.token);
//             localStorage.setItem("username", response?.data?.SDESC?.userid);
//             localStorage.setItem("psswdDays", response?.data?.SDESC?.password_updated_days);
//             localStorage.setItem("roleid", response?.data?.SDESC?.roleid);
//             localStorage.setItem("displayName", response?.data?.SDESC?.dispname);
//             localStorage.setItem("lastlogintime", response?.data?.SDESC?.lastloggedintime);
//             localStorage.setItem("Menu", JSON.stringify(response?.data?.menu));
//             localStorage.setItem("Module", JSON.stringify(response?.data?.modulesList));
//             localStorage.setItem("SubModule", JSON.stringify(response?.data?.submodulesList));
//             localStorage.setItem("OldPassword", response?.data?.SDESC?.orpassword);
//             localStorage.setItem("District", response?.data?.SDESC?.district_id);
//             localStorage.setItem("Mandal", response?.data?.SDESC?.mandal_id);
//             localStorage.setItem("Division", response?.data?.SDESC?.division_id);

//             mainAppguest = createGuest(LOGIN_DOMAIN);
//             console.log("mainAppguest......", mainAppguest);

//             mainAppguest.set("user", JSON.stringify(response.data), function (error, data) {});
//             mainAppguest.set( "portalurl", window.location.origin, function (error, data) {} );

//             store.dispatch({ type: "HIDE_SPINNER" });
//           }
//           if (response?.data?.SCODE === "01") {
//             // navigate("/Verification");
//             navigate("/MenuHead");

//             // if (response?.data?.SDESC?.password_updated_days >= 190) {
//             //   history.push("/changePassword.do")
//             // }
//             // else {
//             //   setLoginEnb(true)
//             //   history.push({ pathname: "/MenuHeader" })
//             // }
//           } else {
//             store.dispatch({ type: "HIDE_SPINNER" });
//             reloadApiData();
//             setLoginEnb(false);
//             ShowAlert(response?.data?.SDESC, "error");
//             formik.setFieldValue("captcha", "");
//           }
//         }
//         return response.data;
//       });
//     },
//   });

//   const togglePassword = () => {
//     if (passwordType === "password") {
//       setPasswordType("text");
//       return;
//     }
//     setPasswordType("password");
//   };
//   const [Captchadata, setCaptchadata] = useState();
//   const [sessioId, setSessionId] = useState();
//   const [isLoading, setIsLoading] = useState(false);

//   useEffect(() => {
//     DesService.getCaptcha()
//       .then((res) => {
//         setCaptchadata(res.data.captchaImageBase64);
//         setSessionId(res.data.sessionId);
//       })
//       .finally(() => {
//         setIsLoading(true);
//       });
//   }, []);

//   const [progress, setProgress] = useState(100);

//   const reloadApiData = () => {
//     DesService.getCaptcha()
//       .then((res) => {
//         // setIsLoading(true);
//         setCaptchadata(res.data.captchaImageBase64);
//         setSessionId(res.data.sessionId);
//       })
//       .catch((error) => {
//         setIsLoading(false);
//       })
//       .finally(() => {
//         setIsLoading(true);
//       });
//   };
//   const [seconds, setSeconds] = useState(0);

//   useEffect(() => {
//     const intervalId = setInterval(() => {
//       if (seconds < 60) {
//         setProgress((prevProgress) => Math.max(prevProgress - 1, 0));
//         setSeconds((prevSeconds) => prevSeconds + 1);
//       } else {
//         reloadApiData();
//         setProgress(100);
//         setSeconds(0);
//       }
//     }, 1000);

//     return () => {
//       clearInterval(intervalId);
//     };
//   }, [seconds]);

//   const CaptchaRefresh = () => {
//     DesService.getCaptcha().then((res) => {
//       setCaptchadata(res.data.captchaImageBase64);
//       setSessionId(res.data.sessionId);
//     });
//   };

//   return (
//     <>
//       <section id="banner-part">
//         <div className="container-fluid px-0">
//           <div className="row m-0">
//             <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 leftside-section position-relative">
//               {/* <div className="logo d-flex">
//                 <img src="images/logo.png" />
//                 <div className="logo-text">
//                   <p>Directorate of Economics & Statistics</p>
//                   <p>Government of Andhra Pradesh</p>
//                 </div>
//               </div> */}

//               <div className="enumaration">
//                 <div className="logo ">
//                   <div className="text-center">
//                     <img src="images/logo.png" className="img-fluid" />
//                   </div>
//                   <div className="logo-text text-center">
//                     <p>Directorate of Economics & Statistics</p>
//                     <p>Government of Andhra Pradesh</p>
//                   </div>
//                 </div>
//               </div>
//               <div className="shape1">
//                 <img src="images/shape1.png" />
//               </div>
//               <div className="shape3">
//                 <img src="images/shape3.png" />
//               </div>
//             </div>
//             <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 rightside-section position-relaive">
//               <div className="login-page">
//                 <img src="images/2.png" className="pond img-fluid" />
//                 <h2>Login</h2>

//                 <FormikProvider value={formik}>
//                   <Form className="loginform form_adjust mt-2" autoComplete="off" style={{ width: "100%" }} onSubmit={formik.handleSubmit}>
//                     <input type="text" name="username" autoComplete="username" tabIndex="-1" aria-hidden="true" style={{ position: "absolute", top: "-1000px", left: "-1000px", opacity: 0, height: 0, width: 0 }} />

//                     <input type="password" name="password" autoComplete="current-password" tabIndex="-1" aria-hidden="true" style={{ position: "absolute", top: "-1000px", left: "-1000px", opacity: 0, height: 0, width: 0 }} />

//                     <InputGroup className="mb-3">
//                       <InputGroup.Text className="group_txt">
//                         <svg stroke="#000000" fill="#000000" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
//                           <path d="M12 2a5 5 0 1 0 5 5 5 5 0 0 0-5-5zm0 8a3 3 0 1 1 3-3 3 3 0 0 1-3 3zm9 11v-1a7 7 0 0 0-7-7h-4a7 7 0 0 0-7 7v1h2v-1a5 5 0 0 1 5-5h4a5 5 0 0 1 5 5v1z"></path>
//                         </svg>
//                       </InputGroup.Text>
//                       <Field name="usr" type="text" autoComplete="off" placeholder="Username" aria-label="usr" className="form-control" spellCheck="false" style={{ color: "white" }} />
//                       <ErrorMessage name="usr" className="text-error" component="div" />
//                     </InputGroup>

//                     <InputGroup className="mb-4">
//                       <InputGroup.Text className="group_txt">
//                         {/* <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" class="font_size" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M12 2C9.243 2 7 4.243 7 7v2H6c-1.103 0-2 .897-2 2v9c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-9c0-1.103-.897-2-2-2h-1V7c0-2.757-2.243-5-5-5zM9 7c0-1.654 1.346-3 3-3s3 1.346 3 3v2H9V7zm9.002 13H13v-2.278c.595-.347 1-.985 1-1.722 0-1.103-.897-2-2-2s-2 .897-2 2c0 .736.405 1.375 1 1.722V20H6v-9h12l.002 9z"></path></svg> */}

//                         <svg stroke="#000000" fill="#000000" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
//                           <path d="M12 2C9.243 2 7 4.243 7 7v2H6c-1.103 0-2 .897-2 2v9c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-9c0-1.103-.897-2-2-2h-1V7c0-2.757-2.243-5-5-5zM9 7c0-1.654 1.346-3 3-3s3 1.346 3 3v2H9V7zm9.002 13H13v-2.278c.595-.347 1-.985 1-1.722 0-1.103-.897-2-2-2s-2 .897-2 2c0 .736.405 1.375 1 1.722V20H6v-9h12l.002 9z"></path>
//                         </svg>
//                       </InputGroup.Text>
//                       <Field name="psd" type={passwordType} autoComplete="off" placeholder="Password" aria-label="psd" aria-describedby="basic-addon1" className="form-control" style={{ borderRadius: "0px" }} />
//                       <span className="input-group-text">{passwordType === "password" ? <FaEyeSlash style={{ color: "blue" }} onClick={togglePassword} /> : <FaEye style={{ color: "#000" }} onClick={togglePassword} />}</span>
//                       <ErrorMessage name="psd" className="text-error" component="div" />
//                     </InputGroup>

//                     <InputGroup className="mb-3">
//                       <InputGroup.Text className="group_txt">
//                         {/* <svg fill="#000000" width="1em" height="auto" style={{ cursor: "pointer" }}  viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className="icon flat-color font_size">
//                           {" "}
//                           <path d="M14.71,17.29l-2-2a1,1,0,0,0-1.42,1.42l.3.29H9A5,5,0,0,1,6.11,7.93,1,1,0,1,0,5,6.29,7,7,0,0,0,2,12a7,7,0,0,0,7,7h2.59l-.3.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0l2-2A1,1,0,0,0,14.71,17.29Z" style={{ fill: "rgb(44, 169, 188)" }} />{" "}
//                           <path d="M20,7.06A6.89,6.89,0,0,0,15,5H12.41l.3-.29a1,1,0,1,0-1.42-1.42l-2,2a1,1,0,0,0,0,1.42l2,2a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42L12.41,7H15a5,5,0,0,1,2.89,9.07A1,1,0,1,0,19,17.71,7,7,0,0,0,22,12,6.89,6.89,0,0,0,20,7.06Z" style={{ fill: "rgb(0, 0, 0)" }} />{" "}
//                         </svg>{" "} */}

//                         <svg stroke="#2b2b2b" fill="#2b2b2b" stroke-width="0" style={{ cursor: "pointer" }} xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" height="1em" width="1em" viewBox="0 0 26 26" onClick={CaptchaRefresh}>
//                           <path d="M 13.8125 0 C 7.878906 0 4.082031 4.292969 4 10 L 0.5 10 C 0.300781 10 0.09375 10.113281 0.09375 10.3125 C -0.0078125 10.511719 -0.0078125 10.710938 0.09375 10.8125 L 6.09375 18.5 C 6.195313 18.601563 6.300781 18.6875 6.5 18.6875 C 6.699219 18.6875 6.804688 18.601563 6.90625 18.5 L 12.90625 10.8125 C 13.007813 10.710938 13.007813 10.511719 12.90625 10.3125 C 12.804688 10.113281 12.601563 10 12.5 10 L 9 10 C 9.066406 2.464844 12.921875 0.789063 13.8125 0.09375 C 14.011719 -0.0078125 14.011719 0 13.8125 0 Z M 19.5 7.34375 C 19.351563 7.34375 19.195313 7.398438 19.09375 7.5 L 13.09375 15.1875 C 12.992188 15.386719 13 15.585938 13 15.6875 C 13.101563 15.886719 13.304688 16 13.40625 16 L 17 16 C 16.933594 23.535156 13.078125 25.210938 12.1875 25.90625 C 11.988281 26.007813 11.988281 26 12.1875 26 C 18.121094 26 21.917969 21.707031 22 16 L 25.40625 16 C 25.605469 16 25.8125 15.886719 25.8125 15.6875 C 26.011719 15.488281 26.007813 15.289063 25.90625 15.1875 L 19.90625 7.5 C 19.804688 7.398438 19.648438 7.34375 19.5 7.34375 Z"></path>
//                         </svg>
//                       </InputGroup.Text>
//                       <span className="captcha">
//                         <img
//                           src={"data:image/png;base64," + Captchadata}
//                           alt="Captcha"
//                           style={{
//                             width: "auto",
//                             height: "37px",
//                             background: "transparent",
//                             border: "none",
//                           }}
//                         />
//                       </span>
//                       <Field placeholder="Enter Captcha" name="captcha" className="form-control" type="text" maxLength={5} autoComplete="off" />
//                       <ErrorMessage name="captcha" component="div" className="text-error" />
//                     </InputGroup>

//                     {isLoading && (
//                       // <div className="progress" style={{ width: "90px", height: "10px" }}>
//                       //   <div className="progress-bar bg-success" role="progressbar" style={{ width: `${progress}%` }} aria-valuenow={progress} aria-valuemin="0" aria-valuemax="100">
//                       //     <span className="progress-text">{` ${seconds}s`}</span>
//                       //   </div>
//                       // </div>
//                          <Progress  strokeColor="#B7EB8F" percent={parseInt(((60 - seconds) / 60) * 100)} format={() => `${60 - seconds}s`}  style={{ width: 120 }} />

//                     )}

//                     {/* ===============================
//       FOOTER
//       =============================== */}
//                     <div className="d-flex justify-content-between">
//                       <div>
//                         <h6 className="forgotpassword mt-2">Forgot Password?</h6>
//                       </div>
//                       <div>
//                         <Button variant="success" type="submit" size="sm" className="float-end d-flex align-items-center gap-2" disabled={loginEnb}>
//                           <span className="d-flex align-items-center pe-1 border-end">
//                             <BsBoxArrowInRight />
//                           </span>
//                           Login
//                         </Button>
//                       </div>
//                     </div>
//                   </Form>
//                 </FormikProvider>
//               </div>
//               <div className="shape2">
//                 <img src="images/shape2.png" />
//               </div>
//               <div className="row">
//                 <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6"></div>
//                 <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 text-right ">
//                   <h2 className="designed">
//                     Designed and Developed By <img src="images/apcfss.svg" className="department" />
//                   </h2>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//     </>
//   );
// }

import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

import { FaBell, FaGraduationCap, FaUniversity, FaChartBar, FaFileAlt, FaRegNewspaper } from "react-icons/fa";

import { NavLink } from "react-router-dom";
import { ErrorMessage, Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ADMIN_DOMAIN,  AREA_STATISTICS,  AS2, ASI_DOMAIN, BUSINESSREG_DOMAIN, ICS_DOMAIN, IIP_DOMAIN, LOGIN_DOMAIN, MDP, PRICE_STATISTICS, RAIN_DOMAIN, SLAP_DOMAIN, TRAS_DOMAIN, VIS_DOMAIN, YIELD_DOMAIN } from "../Services/Configuration.js";
import { store } from "../App.js";
import DesService from "../Services/Des Service.js";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import ShowAlert from "./alert.js";
import { Container, Nav, Navbar, NavDropdown, Button, Form, InputGroup, Modal, Col, Row } from "react-bootstrap";
import { BsBoxArrowInRight } from "react-icons/bs";
import { ComposableMap, Geographies, Geography, Marker } from "react-simple-maps";

import { geoCentroid } from "d3-geo";
import FooterBottom from "./FooterBottom.js";
import { WiDayRainMix } from "react-icons/wi";

export default function Login() {
  var createHost = require("cross-domain-storage/host");
  var createGuest = require("cross-domain-storage/guest");
  var mainAppguest = null;

  var storageHost = null;
  const [loginErrorMsg, setloginErrorMsg] = useState(false);
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [passwordType, setPasswordType] = useState("password");

  const [errMsg, setErrMsg] = useState("");
  const [loginEnb, setLoginEnb] = useState();
  const [captchaInput, setCaptchaInput] = useState("");
  const [captchaText, setCaptchaText] = useState("");
  const canvasRef = useRef(null);
  const [showLogin, setShowLogin] = useState(false);

  useEffect(() => {
    // localStorage.clear();

    storageHost = createHost([
      {
        origin: LOGIN_DOMAIN,
        allowedMethods: ["get", "set", "remove"],
      },
      {
        origin: RAIN_DOMAIN,
        allowedMethods: ["get", "set", "remove"],
      },
      {
        origin: IIP_DOMAIN,
        allowedMethods: ["get", "set", "remove"],
      },
      {
        origin: YIELD_DOMAIN,
        allowedMethods: ["get", "set", "remove"],
      },
      {
        origin: BUSINESSREG_DOMAIN,
        allowedMethods: ["get", "set", "remove"],
      },
      {
        origin: TRAS_DOMAIN,
        allowedMethods: ["get", "set", "remove"],
      },
      {
        origin: ASI_DOMAIN,
        allowedMethods: ["get", "set", "remove"],
      },
      {
        origin: AREA_STATISTICS,
        allowedMethods: ["get", "set", "remove"],
      },
      {
        origin: SLAP_DOMAIN,
        allowedMethods: ["get", "set", "remove"],
      },
      {
        origin: MDP,
        allowedMethods: ["get", "set", "remove"],
      },
      {
        origin: VIS_DOMAIN,
        allowedMethods: ["get", "set", "remove"],
      },
      {
        origin: ADMIN_DOMAIN,
        allowedMethods: ["get", "set", "remove"],
      },
         {
        origin: PRICE_STATISTICS,
        allowedMethods: ["get", "set", "remove"],
      },
         {
        origin: ICS_DOMAIN,
        allowedMethods: ["get", "set", "remove"],
      },
         {
        origin: AS2,
        allowedMethods: ["get", "set", "remove"],
      },
    ]);
    // storageHost.close()
  }, []);

  const initialValues = {
    usr: "",
    psd: "",
    captcha: "",
  };

  const validationSchema = Yup.object().shape({
    usr: Yup.string().required("Required"),
    psd: Yup.string().required("Required"),
    captcha: Yup.string()
      .required("Required")
      .test("is-exactly-5-values", "Invalid Captcha", (value) => {
        return value ? value.split("").filter(Boolean).length === 5 : false;
      }),
  });

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      console.log("username", username);
      let params = { username: values.usr, password: values.psd, capchaId: values.captcha, sessionId: sessioId };
      store.dispatch({ type: "SHOW_SPINNER" });
      DesService.loginDetails(params)
        .then((response) => {
          if (response?.data !== "" && response?.data !== null && response?.data !== undefined) {
            console.log("response?.data?.SCODE" + response?.data?.SCODE);
            if (response.data?.token) {
              console.log(response?.data?.SDESC?.userid);
              console.log(response?.data?.SDESC?.roleid);
              localStorage.setItem("portalurl", window.location.origin);
              localStorage.setItem("user", JSON.stringify(response.data));
              localStorage.setItem("token", response.data?.token);
              localStorage.setItem("username", response?.data?.SDESC?.userid);
              localStorage.setItem("psswdDays", response?.data?.SDESC?.password_updated_days);
              localStorage.setItem("roleid", response?.data?.SDESC?.roleid);
              localStorage.setItem("displayName", response?.data?.SDESC?.dispname);
              localStorage.setItem("lastlogintime", response?.data?.SDESC?.lastloggedintime);
              localStorage.setItem("Menu", JSON.stringify(response?.data?.menu));
              localStorage.setItem("Module", JSON.stringify(response?.data?.modulesList));
              localStorage.setItem("SubModule", JSON.stringify(response?.data?.submodulesList));
              localStorage.setItem("OldPassword", response?.data?.SDESC?.orpassword);
              localStorage.setItem("District", response?.data?.SDESC?.district_id);
              localStorage.setItem("Mandal", response?.data?.SDESC?.mandal_id);
              localStorage.setItem("Division", response?.data?.SDESC?.division_id);

              mainAppguest = createGuest(LOGIN_DOMAIN);
              console.log("mainAppguest......", mainAppguest);

              mainAppguest.set("user", JSON.stringify(response.data), function (error, data) {});
              mainAppguest.set("portalurl", window.location.origin, function (error, data) {});

              store.dispatch({ type: "HIDE_SPINNER" });
            }
            if (response?.data?.SCODE === "01") {
              if (response?.data?.SDESC?.password_updated_days >= 190) {
                 navigate("/changepasswords");
              } else {
                navigate("/MenuHead");
              }
            } else {
              store.dispatch({ type: "HIDE_SPINNER" });
              reloadApiData();
              setLoginEnb(false);
              ShowAlert(response?.data?.SDESC, "error");
              formik.setFieldValue("captcha", "");
            }
          }
          return response.data;
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          store.dispatch({ type: "HIDE_SPINNER" });
        });
    },
  });

  const togglePassword = () => {
    if (passwordType === "password") {
      setPasswordType("text");
      return;
    }
    setPasswordType("password");
  };
  const [Captchadata, setCaptchadata] = useState();
  const [sessioId, setSessionId] = useState();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    DesService.getCaptcha()
      .then((res) => {
        setCaptchadata(res.data.captchaImageBase64);
        setSessionId(res.data.sessionId);
      })
      .finally(() => {
        setIsLoading(true);
      });
  }, []);

  const reloadApiData = () => {
    DesService.getCaptcha()
      .then((res) => {
        // setIsLoading(true);
        setCaptchadata(res.data.captchaImageBase64);
        setSessionId(res.data.sessionId);
      })
      .catch((error) => {
        setIsLoading(false);
      })
      .finally(() => {
        setIsLoading(true);
      });
  };

  const CaptchaRefresh = () => {
    DesService.getCaptcha().then((res) => {
      setCaptchadata(res.data.captchaImageBase64);
      setSessionId(res.data.sessionId);
    });
  };

  const alerts = [
    {
      id: 1,
      title: "Daily Prices",
    },
    {
      id: 2,
      title: "Weekly Prices",
    },
    {
      id: 3,
      title: "Monthly Season & Crop Conditions Apr-26",
    },
    {
      id: 4,
      title: "Monthly Index of Industrial Production June-24",
    },
    {
      id: 5,
      title: " Monthly Prices Bulletin Apr-26",
    },
    {
      id: 6,
      title: "Season and Crop Report 2024-25",
    },
    {
      id: 7,
      title: "Prices Wages & Index Numbers 2024-25",
    },
    {
      id: 8,
      title: "Statistical Abstract 2024",
    },
    {
      id: 9,
      title: " Andhra Pradesh Economy in Brief 2021",
    },
  ];

  const quickLinks = [
    {
      img: "../images/indian_govt.png",
      title: "Govt. of India",
      desc: "Access official Government of India portals and services.",
    },
    {
      img: "../images/aplogo.webp",
      title: "Govt. of AP",
      desc: "Explore Andhra Pradesh Government departments and initiatives.",
    },
    {
      img: "../images/reunion.png",
      title: "Other DE&S",
      desc: "Visit Directorate of Economics & Statistics websites.",
    },
    {
      img: "../images/goir.png",
      title: "AP GOs",
      desc: "View Andhra Pradesh Government Orders and notifications.",
    },
  ];

  const heroSlides = ["/images/desbg.png"];

  const colors = ["#6b4efc", "#4fc3f7", "#81c784", "#ffb74d", "#ef5350", "#26a69a"];

  const ModalClose = async () => {
    setShowLogin(false);
    formik.resetForm();
  };
  return (
    <>
      {/* ================= HEADER ================= */}
      <div style={{ position: "sticky", top: 0, zIndex: 1050, background: "#fff" }}>
        <nav className="navbar navbar-expand-lg shadow-sm">
          <div className="container-fluid">
            <div className="header-logo-area d-flex align-items-center">
              <img src="../images/aplogo.webp" alt="AP Logo" className="logo-img" />
              <div className="header-title ms-3">
                {" "}
                <h1>Directorate of Economics & Statistics</h1> <p>Government of Andhra Pradesh</p>{" "}
              </div>
            </div>

            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarContent">
              <span className="navbar-toggler-icon"></span>
            </button>

            <div className="collapse navbar-collapse" id="navbarContent">
              <ul className="navbar-nav ms-auto align-items-center">
                <li className="menu-item">
                  <a className="menu-link active-menu" href="#" onClick={(e) => e.preventDefault()}>
                    {" "}
                    Home{" "}
                  </a>
                </li>

                <li className="menu-item">
                  <a className="menu-link" href="#" onClick={(e) => e.preventDefault()}>
                    {" "}
                    About Us{" "}
                  </a>
                </li>

                <li className="menu-item">
                  <a className="menu-link" href="#" onClick={(e) => e.preventDefault()}>
                    {" "}
                    Publications{" "}
                  </a>
                </li>
                <li className="menu-item">
                  <a className="menu-link" href="#" onClick={(e) => e.preventDefault()}>
                    {" "}
                    Reports{" "}
                  </a>
                </li>
                <li className="menu-item">
                  {" "}
                  <a className="menu-link" href="#" onClick={(e) => e.preventDefault()}>
                    {" "}
                    Statistics{" "}
                  </a>
                </li>
                <li className="menu-item">
                  <a className="menu-link" href="#" onClick={(e) => e.preventDefault()}>
                    {" "}
                    Contact Us{" "}
                  </a>
                </li>
 <li className="menu-item">
           
                </li>
                {/* <li className="menu-item dropdown">
                  <a href="#" className="menu-link dropdown-toggle" data-bs-toggle="dropdown" onClick={(e) => e.preventDefault()}>
                    PO-2025 Option Form
                    <img
                      src="../images/new.gif"
                      alt="New"
                      style={{
                        width: "30px",
                        marginLeft: "5px",
                        verticalAlign: "middle",
                      }}
                    />
                  </a>

                  <ul className="dropdown-menu">
                    <li>
                      <a
                        className="dropdown-item"
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          window.open("/images/optionform.pdf", "_blank");
                        }}
                      >
                        Download Pdf
                      </a>
                    </li>

                    <li>
                      <a className="dropdown-item" href="/OptionForm">
                        Upload Option Form
                      </a>
                    </li>
                  </ul>
                </li> */}
                <li className="ms-2">
                  <button className="login-btn" onClick={() => setShowLogin(true)}>
                    {" "}
                    Login{" "}
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
      <Modal show={showLogin} onHide={() => ModalClose()} backdrop="static" className="login-modal">
        <Modal.Header closeButton className="login-modal-header p-2">
          <Modal.Title>Login</Modal.Title>
        </Modal.Header>

        <Modal.Body className="login-modal-body p-3">
          <FormikProvider value={formik}>
            <Form className="loginform form_adjust mt-2" autoComplete="off" style={{ width: "100%" }} onSubmit={formik.handleSubmit}>
              <input type="text" name="username" autoComplete="username" tabIndex="-1" aria-hidden="true" style={{ position: "absolute", top: "-1000px", left: "-1000px", opacity: 0, height: 0, width: 0 }} />

              <input type="password" name="password" autoComplete="current-password" tabIndex="-1" aria-hidden="true" style={{ position: "absolute", top: "-1000px", left: "-1000px", opacity: 0, height: 0, width: 0 }} />

              <InputGroup className="mb-3">
                <InputGroup.Text className="group_txt">
                  <svg stroke="#000000" fill="#000000" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http:www.w3.org/2000/svg">
                    <path d="M12 2a5 5 0 1 0 5 5 5 5 0 0 0-5-5zm0 8a3 3 0 1 1 3-3 3 3 0 0 1-3 3zm9 11v-1a7 7 0 0 0-7-7h-4a7 7 0 0 0-7 7v1h2v-1a5 5 0 0 1 5-5h4a5 5 0 0 1 5 5v1z"></path>
                  </svg>
                </InputGroup.Text>
                <Field name="usr" type="text" autoComplete="off" placeholder="Username" aria-label="usr" className="form-control" spellCheck="false" />
                <ErrorMessage name="usr" className="text-error" component="div" />
              </InputGroup>

              <InputGroup className="mb-4">
                <InputGroup.Text className="group_txt">
                  <svg stroke="#000000" fill="#000000" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http:www.w3.org/2000/svg">
                    <path d="M12 2C9.243 2 7 4.243 7 7v2H6c-1.103 0-2 .897-2 2v9c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-9c0-1.103-.897-2-2-2h-1V7c0-2.757-2.243-5-5-5zM9 7c0-1.654 1.346-3 3-3s3 1.346 3 3v2H9V7zm9.002 13H13v-2.278c.595-.347 1-.985 1-1.722 0-1.103-.897-2-2-2s-2 .897-2 2c0 .736.405 1.375 1 1.722V20H6v-9h12l.002 9z"></path>
                  </svg>
                </InputGroup.Text>
                <Field name="psd" type={passwordType} autoComplete="off" placeholder="Password" aria-label="psd" aria-describedby="basic-addon1" className="form-control" style={{ borderRadius: "0px" }} />
                <span className="input-group-text">{passwordType === "password" ? <FaEyeSlash style={{ color: "blue" }} onClick={togglePassword} /> : <FaEye style={{ color: "#000" }} onClick={togglePassword} />}</span>
                <ErrorMessage name="psd" className="text-error" component="div" />
              </InputGroup>

              <InputGroup className="mb-3">
                <InputGroup.Text className="group_txt">
                  <svg stroke="#2b2b2b" fill="#2b2b2b" stroke-width="0" style={{ cursor: "pointer" }} xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" height="1em" width="1em" viewBox="0 0 26 26" onClick={CaptchaRefresh}>
                    <path d="M 13.8125 0 C 7.878906 0 4.082031 4.292969 4 10 L 0.5 10 C 0.300781 10 0.09375 10.113281 0.09375 10.3125 C -0.0078125 10.511719 -0.0078125 10.710938 0.09375 10.8125 L 6.09375 18.5 C 6.195313 18.601563 6.300781 18.6875 6.5 18.6875 C 6.699219 18.6875 6.804688 18.601563 6.90625 18.5 L 12.90625 10.8125 C 13.007813 10.710938 13.007813 10.511719 12.90625 10.3125 C 12.804688 10.113281 12.601563 10 12.5 10 L 9 10 C 9.066406 2.464844 12.921875 0.789063 13.8125 0.09375 C 14.011719 -0.0078125 14.011719 0 13.8125 0 Z M 19.5 7.34375 C 19.351563 7.34375 19.195313 7.398438 19.09375 7.5 L 13.09375 15.1875 C 12.992188 15.386719 13 15.585938 13 15.6875 C 13.101563 15.886719 13.304688 16 13.40625 16 L 17 16 C 16.933594 23.535156 13.078125 25.210938 12.1875 25.90625 C 11.988281 26.007813 11.988281 26 12.1875 26 C 18.121094 26 21.917969 21.707031 22 16 L 25.40625 16 C 25.605469 16 25.8125 15.886719 25.8125 15.6875 C 26.011719 15.488281 26.007813 15.289063 25.90625 15.1875 L 19.90625 7.5 C 19.804688 7.398438 19.648438 7.34375 19.5 7.34375 Z"></path>
                  </svg>
                </InputGroup.Text>
                <span className="captcha">
                  <img
                    src={"data:image/png;base64," + Captchadata}
                    alt="Captcha"
                    style={{
                      width: "auto",
                      height: "37px",
                      background: "transparent",
                      border: "none",
                    }}
                  />
                </span>
                <Field placeholder="Enter Captcha" name="captcha" className="form-control" type="text" maxLength={5} autoComplete="off" />
                <ErrorMessage name="captcha" component="div" className="text-error" />
              </InputGroup>
              <div className="d-flex justify-content-between">
                <div>{/* <h6 className="forgotpassword mt-2">Forgot Password?</h6> */}</div>
                <div>
                  <Button variant="success" type="submit" size="sm" className="float-end d-flex align-items-center gap-2" disabled={loginEnb}>
                    <span className="d-flex align-items-center pe-1 border-end">
                      <BsBoxArrowInRight />
                    </span>
                    Login
                  </Button>
                </div>
              </div>
            </Form>
          </FormikProvider>
        </Modal.Body>
      </Modal>

      {/* ================= HERO CAROUSEL ================= */}
      <section className="hero-section">
        <Swiper modules={[Pagination, Autoplay]} pagination={{ clickable: true }} autoplay={{ delay: 4000 }} loop>
          {heroSlides.map((img, i) => (
            <SwiperSlide key={i}>
              <div className="hero-slide">
                <img src={img} alt="" className="hero-banner" />

                <div className="hero-content">
                  <h1>
                    Welcome to
                    <br />
                    Directorate of
                    <br />
                    <span>Economics & Statistics.</span>
                  </h1>

                  <p>Directorate of Economics and Statistics is the "Nodal Agency" for all statistical activities in all the State Government Departments.</p>

                  <button className="explore-btn" onClick={() => window.open("http://desweather.ap.gov.in/", "_blank")}>
                    Andhra Pradesh Real Time Weather <WiDayRainMix style={{ fontSize: "25px" }} />
                    <span>→</span>
                  </button>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>

      {/* ================= ALERTS + QUICK LINKS ================= */}

      <Container fluid style={{ width: "95%" }} className="py-4">
        <div className="row g-4">
          <div className="col-lg-4">
            <div className="alerts-card">
              <div className="alerts-header">
                <FaBell />
                <span>What's New</span>
              </div>

              <div className="alerts-body">
                <Swiper direction="vertical" slidesPerView={3} spaceBetween={2} loop={true} speed={4000} autoplay={{ delay: 0, disableOnInteraction: false, pauseOnMouseEnter: true }} modules={[Autoplay]} className="alerts-swiper">
                  {[...alerts, ...alerts].map((item, index) => (
                    <SwiperSlide key={index}>
                      <div className="alert-item">
                        <div className="alert-circle">
                          <FaRegNewspaper />
                        </div>
                        <div className="alert-title">{item.title}</div>
                        <div className="arrow">›</div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>

              <div className="view-all">View All →</div>
            </div>
          </div>

          {/* QUICK LINKS */}

          <div className="col-lg-8">
            <h5 className="section-title">
              Quick <span>Links</span>
            </h5>

            <div className="row g-3">
              {quickLinks.map((item, index) => (
                <div className="col-md-6 col-xl-3" key={index}>
                  <div className="quick-card">
                    <div className="quick-icon">
                      <img src={item.img} alt={item.title} />
                    </div>

                    <h6>{item.title}</h6>

                    <p>{item.desc}</p>

                    <span className="explore-link">Explore →</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Container>

      {/* ================= ABOUT DES + WHATS NEW ================= */}
      <Container fluid style={{ width: "95%" }} className="py-4">
        <Row>
          <Col xxl={3} xl={3} lg={3} md={4} sm={6} xs={6}>
            <div className="minister-all cm-box">
              <img src="../images/plan-cm.png" className="img-fluid" />
              <div className="minister-title">
                <h3>Sri Nara Chandrababu Naidu</h3>
                <h5>Hon'ble Chief Minister</h5>
              </div>
            </div>
          </Col>
          <Col xxl={3} xl={3} lg={3} md={4} sm={6} xs={6}>
            <div className="minister-all min-box">
              <img src="../images/plan-minister.png" className="img-fluid" />
              <div className="minister-title">
                <h3>Sri Payyavula Keshav</h3>
                <h5>Hon'ble Minister for Finance, Planning, Commercial Taxes & Legislative Affairs.</h5>
              </div>
            </div>
          </Col>
          <div className="col-lg-6">
            <div className="about-card">
              <div className="row align-items-center">
                <div className="col-md-7">
                  <h3>
                    About <span>DE&S</span>
                  </h3>

                  <p>Directorate of Economics and Statistics is the Centralized Statistical Organization of the State for systematic data collection, compilation, analysis and interpretation of Statistical data over a vast range of sectors of economy, to guide and to meet the ever challenging needs of the Government.</p>

                  <button className="read-more-btn">Know More →</button>
                </div>

                <div className="col-md-5 text-center">
                  <img src="../images/aboutimg.png" alt="About DES" className="about-img" />
                </div>
              </div>
            </div>
          </div>
        </Row>
      </Container>

      <Container fluid style={{ width: "95%" }} className="py-4">
        <h5 class="section-title">
          Andhra Pradesh <span>Profile</span>
        </h5>
        <div className="row g-3">
          {/* About Card */}
          <div className="col-lg-6">
            <div className="plan-real">
              <div className="row align-items-center">
                <ComposableMap
                  projection="geoMercator"
                  projectionConfig={{
                    scale: 5000,
                    center: [80.7, 15.8],
                  }}
                  style={{
                    width: "100%",
                    height: "250px",
                  }}
                >
                  <Geographies geography="/images/andhra_pradesh.geojson">
                    {({ geographies }) => (
                      <>
                        {geographies.map((geo, index) => {
                          const centroid = geoCentroid(geo);

                          return (
                            <React.Fragment key={geo.rsmKey}>
                              <Geography
                                geography={geo}
                                fill={colors[index % colors.length]}
                                stroke="#ffffff"
                                strokeWidth={1}
                                onClick={() => window.open(`https://${geo.properties.District.toLowerCase().replace(/[^a-zA-Z0-9]/g, "")}.ap.gov.in/`, "_blank")}
                                style={{
                                  default: {
                                    outline: "none",
                                  },
                                  hover: {
                                    fill: "#ff962d",
                                    outline: "none",
                                    cursor: "pointer",
                                  },
                                  pressed: {
                                    outline: "none",
                                  },
                                }}
                              >
                                <title>{geo.properties.District}</title>
                              </Geography>

                              <Marker coordinates={centroid}>
                                <text
                                  textAnchor="middle"
                                  style={{
                                    fontSize: "10px",
                                    fill: "#07295f",
                                    fontWeight: "700",
                                    strokeWidth: "1px",
                                    paintOrder: "stroke",
                                    pointerEvents: "none",
                                    userSelect: "none",
                                  }}
                                >
                                  {geo.properties.District}
                                </text>
                              </Marker>
                            </React.Fragment>
                          );
                        })}
                      </>
                    )}
                  </Geographies>
                </ComposableMap>
              </div>
            </div>
          </div>

          {/* Map Card */}
          <Col xxl={3} xl={3} lg={3} md={3} sm={6} xs={12} className="plan-link-slide-move">
            <div className="plan-check-box">
              <ul>
                <li>
                  <a href="#">
                    <img src="../images/plan-link-check.svg" /> <span>Area: 162.97 ('000 Sq.Kms)</span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img src="../images/plan-link-check.svg" /> <span> Households: 1,27,18,976 </span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img src="../images/plan-link-check.svg" /> <span> Population: 4,95,77,103 </span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img src="../images/plan-link-check.svg" /> <span> Male: 2,48,30,513 </span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img src="../images/plan-link-check.svg" /> <span> Female: 2,47,46,590 </span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img src="../images/plan-link-check.svg" /> <span> Literacy Rate: 67.35% </span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img src="../images/plan-link-check.svg" /> <span>Districts: 28</span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img src="../images/plan-link-check.svg" /> <span>Revenue Divisions: 82 </span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img src="../images/plan-link-check.svg" /> <span>Revenue Mandals: 688</span>
                  </a>
                </li>
              </ul>
            </div>
          </Col>
          <Col xxl={3} xl={3} lg={3} md={3} sm={6} xs={12} className="plan-link-slide-move">
            <div className="plan-check-box">
              <ul>
                <li>
                  <a href="#">
                    <img src="../images/plan-link-check.svg" /> <span>Rural Mandals: 663</span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img src="../images/plan-link-check.svg" /> <span>Urban Mandals: 25</span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img src="../images/plan-link-check.svg" /> <span>Revenue Villages: 17,464</span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img src="../images/plan-link-check.svg" /> <span>Municipal Corp: 17</span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img src="../images/plan-link-check.svg" /> <span> Municipalities/NP: 106 </span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img src="../images/plan-link-check.svg" /> <span> Panchayats: 13,351 </span>
                  </a>
                </li>

                <li>
                  <a href="#">
                    <img src="../images/plan-link-check.svg" /> <span> Assembly: 175</span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img src="../images/plan-link-check.svg" /> <span> Parliament: 25</span>
                  </a>
                </li>
              </ul>
            </div>
          </Col>
        </div>
      </Container>

      <Container fluid style={{ width: "95%" }} className="py-4">
        <h5 class="section-title">
          More <span>Information</span>
        </h5>
        <Row className="plan-update">
          <Col xxl={3} xl={3} lg={3} md={6} sm={6} xs={12} className="mb-4">
            <div className="update-card update-economic">
              <div className="update-circle">
                <img src="../images/plan-updates-rti.svg" className="" />
              </div>
              <h3>Right to Information Act</h3>
            </div>
          </Col>
          <Col xxl={3} xl={3} lg={3} md={6} sm={6} xs={12} className="mb-4">
            <div className="update-card update-income">
              <div className="update-circle">
                <img src="../images/plan-updates-manuals.svg" className="" />
              </div>
              <h3>Manuals & Orders</h3>
            </div>
          </Col>
          <Col xxl={3} xl={3} lg={3} md={6} sm={6} xs={12} className="mb-4">
            <div className="update-card update-district">
              <div className="update-circle">
                <img src="../images/plan-updates-administration.svg" className="" />
              </div>
              <h3>Annual Administration</h3>
            </div>
          </Col>
          <Col xxl={3} xl={3} lg={3} md={6} sm={6} xs={12} className="mb-4">
            <div className="update-card update-census">
              <div className="update-circle">
                <img src="../images/plan-updates-census.svg" className="" />
              </div>
              <h3>Census & Surveys</h3>
            </div>
          </Col>
        </Row>
      </Container>

      <FooterBottom />
    </>
  );
}
